import React, { useState, useEffect } from 'react';

const AddVendorModal = ({ isOpen, onClose, eventId, onVendorAdded }) => {
  const [allVendors, setAllVendors] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState('');
  const [loading, setLoading] = useState(false);
  const [showManualForm, setShowManualForm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [manualVendor, setManualVendor] = useState({
    name: '',
    address: '',
    email: '',
    phone: '',
    vendorType: 'vendor'
  });

  useEffect(() => {
    if (isOpen) {
      loadVendors();
    }
  }, [isOpen]);

  const loadVendors = async () => {
    try {
      const response = await fetch('https://etz8ecs10a.execute-api.ap-southeast-2.amazonaws.com/prod/api/vendors');
      if (response.ok) {
        const data = await response.json();
        if (data && Array.isArray(data)) {
          const standardized = data.map(vendor => {
            const v = {};
            for (const [key, value] of Object.entries(vendor)) {
              if (value?.S !== undefined) v[key] = value.S;
              else if (value?.N !== undefined) v[key] = parseInt(value.N);
              else if (value?.BOOL !== undefined) v[key] = value.BOOL;
              else v[key] = value;
            }
            return v;
          });
          
          const eventVendorsResponse = await fetch(`https://etz8ecs10a.execute-api.ap-southeast-2.amazonaws.com/prod/api/events/${eventId}/vendors`);
          let linkedVendorIds = [];
          if (eventVendorsResponse.ok) {
            const eventVendors = await eventVendorsResponse.json();
            linkedVendorIds = eventVendors.map(v => v.vendorId);
          }
          
          const availableVendors = standardized.filter(v => !linkedVendorIds.includes(v.id));
          setAllVendors(availableVendors);
        }
      }
    } catch (error) {
      console.error('Error loading vendors:', error);
    }
  };



  const handleAddVendor = async () => {
    if (!selectedVendorId) return;
    
    setLoading(true);
    try {
      const response = await fetch(`https://etz8ecs10a.execute-api.ap-southeast-2.amazonaws.com/prod/api/events/${eventId}/vendors`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          vendorId: selectedVendorId,
          isPrimary: 'false'
        })
      });
      
      if (response.ok) {
        onVendorAdded();
        onClose();
        setSelectedVendorId('');
      }
    } catch (error) {
      console.error('Error adding vendor:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateVendor = async () => {
    if (!manualVendor.name) return;
    
    setLoading(true);
    try {
      const vendorId = `vendor-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      
      const createResponse = await fetch('https://etz8ecs10a.execute-api.ap-southeast-2.amazonaws.com/prod/api/vendors', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: vendorId,
          ...manualVendor,
          isRegistered: false,
          status: 'pending'
        })
      });
      
      if (createResponse.ok) {
        const linkResponse = await fetch(`https://etz8ecs10a.execute-api.ap-southeast-2.amazonaws.com/prod/api/events/${eventId}/vendors`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            vendorId: vendorId,
            isPrimary: 'false'
          })
        });
        
        if (linkResponse.ok) {
          setShowSuccess(true);
        }
      }
    } catch (error) {
      console.error('Error creating vendor:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px',
        width: '600px',
        position: 'relative'
      }}>
        <h3 style={{
          fontSize: '32px',
          fontWeight: '400',
          color: '#1F2937',
          marginBottom: '24px',
          fontFamily: 'Georgia, serif'
        }}>
          Add Vendor
        </h3>

        {showSuccess ? (
          <div style={{ textAlign: 'center', padding: '40px 20px' }}>
            <div style={{
              width: '80px',
              height: '80px',
              backgroundColor: '#6B9080',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px'
            }}>
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3">
                <polyline points="20,6 9,17 4,12"></polyline>
              </svg>
            </div>
            <h4 style={{ fontSize: '20px', fontWeight: '500', color: '#1F2937', marginBottom: '12px' }}>
              Vendor Added Successfully!
            </h4>
            <p style={{ fontSize: '15px', color: '#6B7280', lineHeight: '1.6', marginBottom: '32px' }}>
              Ask your vendor to follow email instructions to onboard themselves into Everset.
            </p>
            <button
              onClick={() => {
                setShowSuccess(false);
                setShowManualForm(false);
                setManualVendor({ name: '', address: '', email: '', phone: '', vendorType: 'vendor' });
                onVendorAdded();
                onClose();
              }}
              style={{
                padding: '12px 32px',
                backgroundColor: '#6B9080',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer'
              }}
            >
              Done
            </button>
          </div>
        ) : !showManualForm ? (
          <>
            <div style={{ marginBottom: '24px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px', display: 'block' }}>
                Select Vendor
              </label>
              <select
                value={selectedVendorId}
                onChange={(e) => setSelectedVendorId(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  backgroundColor: 'white',
                  cursor: 'pointer'
                }}
              >
                <option value="">Select a vendor...</option>
                {allVendors.map(vendor => (
                  <option key={vendor.id} value={vendor.id}>
                    {vendor.name} {vendor.category ? `- ${vendor.category}` : ''}
                  </option>
                ))}
              </select>
              
              <div style={{ fontSize: '13px', color: '#6B7280', marginTop: '8px' }}>
                Can't find your vendor? <span 
                  onClick={() => setShowManualForm(true)}
                  style={{ color: '#6B9080', cursor: 'pointer', textDecoration: 'underline' }}
                >
                  Click here
                </span> to add them manually.
              </div>
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  onClose();
                  setSelectedVendorId('');
                }}
                style={{
                  padding: '12px 32px',
                  backgroundColor: 'white',
                  color: '#6B7280',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleAddVendor}
                disabled={!selectedVendorId || loading}
                style={{
                  padding: '12px 32px',
                  backgroundColor: selectedVendorId && !loading ? '#6B9080' : '#E5E7EB',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: selectedVendorId && !loading ? 'pointer' : 'not-allowed'
                }}
              >
                {loading ? 'Adding...' : 'Add Vendor'}
              </button>
            </div>
          </>
        ) : (
          <>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px', display: 'block' }}>Name</label>
              <input
                type="text"
                placeholder="Aa"
                value={manualVendor.name}
                onChange={(e) => setManualVendor({...manualVendor, name: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  backgroundColor: '#F9FAFB'
                }}
              />
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px', display: 'block' }}>Address</label>
              <input
                type="text"
                placeholder="Aa"
                value={manualVendor.address}
                onChange={(e) => setManualVendor({...manualVendor, address: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  backgroundColor: '#F9FAFB'
                }}
              />
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px', display: 'block' }}>Type</label>
              <select
                value={manualVendor.vendorType}
                onChange={(e) => setManualVendor({...manualVendor, vendorType: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  backgroundColor: '#F9FAFB',
                  cursor: 'pointer'
                }}
              >
                <option value="vendor">Vendor</option>
                <option value="venue">Venue</option>
              </select>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px', display: 'block' }}>Email</label>
              <input
                type="email"
                placeholder="sam@gmail.com"
                value={manualVendor.email}
                onChange={(e) => setManualVendor({...manualVendor, email: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  backgroundColor: '#F9FAFB'
                }}
              />
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '8px', display: 'block' }}>Phone</label>
              <input
                type="tel"
                placeholder="+64 21 123 4567"
                value={manualVendor.phone}
                onChange={(e) => setManualVendor({...manualVendor, phone: e.target.value})}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  backgroundColor: '#F9FAFB'
                }}
              />
            </div>

            <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowManualForm(false);
                  setManualVendor({ name: '', address: '', email: '', phone: '', vendorType: 'vendor' });
                }}
                style={{
                  padding: '12px 32px',
                  backgroundColor: 'white',
                  color: '#6B7280',
                  border: '1px solid #E5E7EB',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleCreateVendor}
                disabled={!manualVendor.name || loading}
                style={{
                  padding: '12px 32px',
                  backgroundColor: manualVendor.name && !loading ? '#6B9080' : '#E5E7EB',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: manualVendor.name && !loading ? 'pointer' : 'not-allowed'
                }}
              >
                {loading ? 'Adding...' : 'Add Vendor'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AddVendorModal;
